var React = require('react');

function Chat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.78 10.392c-1.815.788-3.03 2.22-3.03 3.858 0 .95.41 1.832 1.108 2.56L2.75 18.75H9c1.895 0 3.593-.607 4.74-1.566M8.75 9.75c0 2.485 2.798 4.5 6.25 4.5h6.25l-1.108-1.94c.698-.728 1.108-1.61 1.108-2.56 0-2.485-2.798-4.5-6.25-4.5s-6.25 2.015-6.25 4.5z","stroke":"#0B0C0C","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Chat.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Chat;

Chat.default = Chat;
